export default __webpack_public_path__ + "static/media/72t.709f3649.jpg";